/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse
 */
export interface FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse
     */
    ActivatedBranch: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse(value: object): value is FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse {
    if (!('ActivatedBranch' in value) || value['ActivatedBranch'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseFromJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ActivatedBranch': json['ActivatedBranch'],
    };
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseToJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseToJSONTyped(value?: FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ActivatedBranch': value['ActivatedBranch'],
    };
}

